export const DEFAULT_ROWS = 20
export const ORG_SEARCH_DEBOUNCE_MS = 300
export const ROWS_PER_PAGE_OPTIONS = [5, 10, 20, 50, 100]
export const SALES_TABLE_MAX_HEIGHT = 480
/** Must match backend `REPORTS_CALENDAR_TIMEZONE` (business calendar for default range). */
export const REPORTS_CALENDAR_TZ = 'Asia/Dhaka'
